import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoClass } from "@/shared/model/edo-class.model";
import { getEntity as getClass } from "@/shared/reducers/entities/edo-class.reducer";
import { Card } from "@/components/ui";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import CoursesGroup from "./components/CoursesGroup";

const ClassDetail = () => {
  const dispatch = useAppDispatch();
  const params = useParams<{ id: string }>();
  const { entity: edoClass } = useAppSelector<EntityState<IEdoClass>>(
    (state) => state.edoClass
  );

  useEffect(() => {
    if (params.id) dispatch(getClass(params.id));
  }, [params.id, dispatch]);

  const title = edoClass?.id
    ? `${edoClass.year?.year ?? ""}° ${edoClass.section ?? ""} - ${edoClass.school?.type ?? ""} ${edoClass.school?.subtype ?? ""}${edoClass.school?.name ? " " + edoClass.school.name : ""}`
    : null;

  return (
    <Card className="overflow-hidden rounded-3xl border border-[var(--color-mockup-border)] shadow-card bg-surface p-0">
      <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/30 px-5 py-4">
        {title ? (
          <h2 className="font-heading text-lg font-bold text-[var(--color-mockup-text)]">
            {title}
          </h2>
        ) : (
          <div className="h-6 w-2/3 animate-pulse rounded bg-[var(--color-mockup-border)]" />
        )}
      </div>
      {edoClass && <CoursesGroup class={edoClass} />}
    </Card>
  );
};

export default ClassDetail;
